module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BookItalic-d2454548ded1a152531e3d59a7160349.woff";